export default __webpack_public_path__ + "static/media/image5.4f2de60b.jpg";